const resource = '/v1/proposals';

export default $axios => ({
  index(config) {
    return $axios.get(`${resource}/get-list-calendar`, config);
  },

  show(id, config) {
    return $axios.get(`${resource}/${id}`, config);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  update(id, payload) {
    return $axios.post(`${resource}/${id}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  updateStatus(id, status) {
    return $axios.post(`${resource}/update-status/${id}`, {status: status});
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  },

  updateTaskStatus(payload) {
    return $axios.put(`${resource}/update-task-status`, payload);
  },

  updateStepStatus(payload) {
    return $axios.put(`${resource}/update-step-status`, payload);
  },

  getEmployeeList(id) {
    return $axios.get(`${resource}/get-employee-list/${id}`);
  },

  getListUserByCompany() {
    return $axios.get(`${resource}/get-list-user-company`);
  },

  findProposalFromRedisByKey(key) {
    return $axios.get(`${resource}/find-from-redis-by-key/${key}`);
  },

  saveAsManual(id) {
    return $axios.post(`${resource}/save-as-manual`, {id});
  },

  assignStep(payload) {
    return $axios.post(`${resource}/assign-step`, payload);
  },

  assignTask(payload) {
    return $axios.post(`${resource}/assign-task`, payload);
  },

  deleteProposalByEncryptId(proposalEncryptId) {
    return $axios.delete(`${resource}/${proposalEncryptId}`);
  },

  preview(path, isLsFile) {
    return $axios.get(`${resource}/preview/${path}?lsFile=${+isLsFile}`);
  },

  deleteProposal(id) {
    return $axios.delete(`${resource}/${id}`);
  },
  
  getProposalFromLs(payload) {
    return $axios.post(`${resource}/get-proposal-from-ls`, payload)
  },

  getProposalDashboard() {
    return $axios.get(`${resource}/get-proposal-dashboard`)
  },

  getTodoDashboard() {
    return $axios.get(`${resource}/get-todo-dashboard`)
  },

  getTodoChartDashboard() {
    return $axios.get(`${resource}/get-todo-chart-dashboard`)
  },

  getTodoList(payload) {
    const page = payload !== undefined && payload.page > 0 ? payload.page : 1;
    return $axios.get(`${resource}/get-todo-list?page=${page}`, {params: payload})
  },

  saveDashboardModal(payload) {
    return $axios.put(`${resource}/save-proposal-dashboard-modal`, payload)
  },

  updateTodoDeadline(payload) {
    return $axios.put(`${resource}/update-todo-deadline`, payload);
  },

  cloneCalendarTodo(payload) {
    return $axios.post(`${resource}/clone-calendar-todo`, payload);
  },

  fetchProcessingTodo(payload) {
    return $axios.get(`${resource}/fetch-processing-todo`, {params: payload});
  },
});
